import React from 'react';

export function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      <div className="container mx-auto px-6 py-12">
        <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
        <div className="prose max-w-none">
          <p className="text-lg mb-6">Last updated: {new Date().toLocaleDateString()}</p>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. Agreement to Terms</h2>
            <p className="mb-4">By accessing or using our services, you agree to be bound by these Terms of Service and all applicable laws and regulations.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Services</h2>
            <p className="mb-4">We provide computer repair, maintenance, and IT support services for residential customers in Las Vegas. Our services include:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Computer repair and maintenance</li>
              <li>Network setup and troubleshooting</li>
              <li>Security solutions</li>
              <li>Data backup services</li>
              <li>Hardware upgrades</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Service Appointments</h2>
            <p className="mb-4">We strive to provide same-day service when available. However, appointment availability may vary based on demand and technician availability.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Payment Terms</h2>
            <p className="mb-4">Payment is due upon completion of service. We accept major credit cards, cash, and approved payment methods.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Warranty and Guarantees</h2>
            <p className="mb-4">We provide a satisfaction guarantee on all our services. Specific warranty terms may vary by service type.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. Limitation of Liability</h2>
            <p className="mb-4">We are not responsible for data loss during service. We recommend backing up your data before any service appointment.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">7. Contact Information</h2>
            <p className="mb-4">For questions about these Terms of Service, please contact us at:</p>
            <ul className="list-none pl-6 mb-4">
              <li>Email: help@lvcomputerhelp.com</li>
              <li>Phone: 1 (833) HELP-702</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}